export default __webpack_public_path__ + "static/media/main3(5).cebe284f.png";